export const anonymousThoughts = [
  {
    id: "1",
    content:
      "Reading about self-compassion here changed how I talk to myself. I used to be so harsh, but now I pause and ask — would I say this to a friend? The answer is always no. Thank you for putting this into words.",
    date: "May 24, 2026",
  },
  {
    id: "2",
    content:
      "The article on anxiety made me feel seen. I did not realize that constant overthinking was not normal. I finally booked my first therapy session. This blog gave me the push I needed.",
    date: "May 20, 2026",
  },
  {
    id: "3",
    content:
      "I have been working on setting boundaries with my family, and it is terrifying. The piece on boundaries without guilt reminded me that protecting my peace is not selfish. It is necessary.",
    date: "May 18, 2026",
  },
  {
    id: "4",
    content:
      "Mindfulness always felt like something I did not have time for. Your article on weaving it into daily moments helped me realize that even washing dishes can be a mindful practice. Small shifts, big changes.",
    date: "May 12, 2026",
  },
  {
    id: "5",
    content:
      "The sleep and stress article came at the perfect time. I have been struggling with insomnia for months, and the gentle strategies you shared — especially the breathing technique — actually helped me fall asleep last night.",
    date: "May 5, 2026",
  },
  {
    id: "6",
    content:
      "I was skeptical about therapy for years. The myths debunking article made me feel like it was written for me. I am now considering it without the shame I used to carry. Thank you.",
    date: "April 28, 2026",
  },
];